import { FormBlock } from '@westhetics/ui'
import type { EmailOption, IdentityActions, IdentityDocument, Prefill } from '../identity/api'
import { CodePanel } from '../identity/code-panel'

/**
 * O preenchimento rápido na recepção (RN-PAC-58, T58): quando o documento digitado já tem cadastro
 * com e-mail em outra clínica da Westhetics, os dados entram com o código que a pessoa recebe no
 * e-mail e diz à recepção. Sem o código, nada da outra clínica aparece, e o e-mail não entra.
 */

export function ReceptionIdentityBlock({
  document,
  options,
  actions,
  onPrefilled,
}: {
  document: IdentityDocument
  options: EmailOption[]
  actions: IdentityActions
  onPrefilled: (prefillId: string, prefill: Prefill) => void
}) {
  return (
    <FormBlock
      title="Cadastro na Westhetics"
      note="Esta pessoa já tem cadastro em outra clínica que usa a Westhetics. Os dados dela entram com o código que ela recebe no e-mail: mande o código e peça a ela."
    >
      <CodePanel
        options={options}
        onSend={(emailId) => actions.code.mutateAsync({ document, emailId })}
        onConfirm={async (emailId, code) => {
          const result = await actions.verify.mutateAsync({ document, emailId, code })
          onPrefilled(result.prefillId, result.prefill)
        }}
        confirmLabel="Trazer os dados"
        confirmingLabel="Trazendo…"
        codeHint="Peça à pessoa o código de 6 dígitos que chegou no e-mail."
      />
    </FormBlock>
  )
}
